import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NameDisplay({ label, name, htmlFor }) {
    return (_jsxs("div", { className: "profile-grid-cell", children: [_jsx("span", { "aria-label": htmlFor, children: _jsx("strong", { children: label }) }), _jsx("output", { id: htmlFor, className: "display-data verified", children: name })] }));
}
